import { Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appIntegerOnly]'
})
export class IntegerOnlyDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    if (!/[0-9]/.test(event.key) && !['Backspace','Tab','ArrowLeft','ArrowRight','Delete'].includes(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const paste = event.clipboardData?.getData('text') || '';
    if (!/^[0-9]+$/.test(paste)) {
      event.preventDefault();
    }
  }
}
